import { useMemo } from "react";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { getStripe } from "@/lib/stripe";

interface Props {
  clientSecret: string;
}

export default function StripeEmbeddedCheckout({ clientSecret }: Props) {
  // Stable closure so EmbeddedCheckoutProvider doesn't remount.
  const options = useMemo(
    () => ({ fetchClientSecret: async () => clientSecret }),
    [clientSecret],
  );
  return (
    <div id="checkout" className="w-full">
      <EmbeddedCheckoutProvider stripe={getStripe()} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
